import staticFooterURL from "@adapters/infrastructures/urlConfig/StaticFooterPages/staticFooter";
class FeedbackRepository {
    constructor(http) {
        this.http = http;
    }
    async sendFeedback(payload) {
        try {
            const feedback = await this.http.request({
                method: "POST",
                url: new URL(staticFooterURL.feedbackUrl).toString(),
                body: {
                    nm: payload.name,
                    em: payload.email,
                    mob: payload.mobile,
                    mod: payload.mod,
                    rtg: payload.rtg,
                    opt: payload.selectoption,
                    cmmt: payload.comment,
                    dev: payload.dev,
                    pg: payload.pg,
                    url: payload.url,
                    ptf: payload.ptf,
                    imgs: payload.imgs,
                    brw: payload.brw,
                    accode: payload.accode,
                },
            });
            if (feedback) {
                return feedback.status;
            }
        }
        catch (e) {
            return false;
        }
    }
}
export default FeedbackRepository;
